import Url from '../global/Url';

async function getValidacionBase(Celular) {
    try {
        const response = await fetch(Url.Crm + 'validar-base?phone=' + encodeURIComponent(Celular));
        const responseJson = await response.json();
        const res = responseJson.body;
        return Array.isArray(res) ? res : [];
    } catch (error) {
        console.error(`ERROR VALIDACION: ${error}`);
        return [];
    }
}

export { getValidacionBase };
